import React from "react";

function AirportTransfer() {
  return (
    <section className="mb-16">
      {/* Hero Section */}
      <div className="text-center mb-12">
                  <div className="inline-flex items-center justify-center mb-6">
            <img 
              src="/images/araliya-tours-logo.png" 
              alt="Araliya Tours" 
              className="h-36 w-auto drop-shadow-lg filter" 
            />
          </div>
        <p className="text-sm uppercase tracking-widest text-blue-700/70 font-semibold mb-2">
          Premium Service
        </p>
        <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 font-poppins mb-3">
          Airport Transfers
        </h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
          Professional airport pickup and dropoff service with luggage handling, 
          flight monitoring, and meet & greet assistance.
        </p>
        
        {/* CTA Button */}
        <a
          href="/airport-transfers"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:from-blue-700 hover:to-blue-800 transform hover:scale-[1.02] transition-all duration-200"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          Book Airport Transfer
        </a>
      </div>
      
      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center p-6 bg-white/60 backdrop-blur rounded-2xl border border-white/40">
          <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h4 className="font-semibold text-gray-900 mb-2">Flight Monitoring</h4>
          <p className="text-sm text-gray-600">Real-time flight tracking for perfect timing</p>
        </div>
        
        <div className="text-center p-6 bg-white/60 backdrop-blur rounded-2xl border border-white/40">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <h4 className="font-semibold text-gray-900 mb-2">Luggage Handling</h4>
          <p className="text-sm text-gray-600">Professional assistance with all your bags</p>
        </div>
        
        <div className="text-center p-6 bg-white/60 backdrop-blur rounded-2xl border border-white/40">
          <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h4 className="font-semibold text-gray-900 mb-2">Meet & Greet</h4>
          <p className="text-sm text-gray-600">Seamless transfers with simple, coordinated pickup</p>
        </div>
      </div>
    </section>
  );
}

export default AirportTransfer;
